module.exports = __webpack_public_path__ + "img/logo.4ec6862b.png";